import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const postToggleFavourite = http.post<object, companyagreementApi.ProposalCreateVariables, object>(
  apiBaseUrl + '/favourites/toggle',
  async () => {
    return HttpResponse.json({})
  },
)
